export default "__VITE_ASSET__Cw$QTw7I__"